/* eslint-disable */
<template>
    <span>
        <!--v-navigation-drawer
            app
            v-model="drawer"
            class="brown lighten-2"
            dark
            disable-resize-watcher
        >
            <v-list>
                <template v-for="(item, index) in items">
                    <v-list-tile :key="index" :to="item.url">
                        <v-list-tile-content>
                            {{ item.title }}
                        </v-list-tile-content>
                    </v-list-tile>
                    <v-divider :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-navigation-drawer-->
        <v-toolbar app color="black" dark>
            <!--v-toolbar-side-icon
                class="hidden-md-and-up"
                @click="drawer = !drawer"
            ></v-toolbar-side-icon-->
            <router-link to="/">
                <v-toolbar-title data-cy="titleBtn">
                    <img
                        class="menuLogo ml-0"
                        src="../assets/images/Logo.png"
                        style="height: 45px"
                    />
                </v-toolbar-title>
            </router-link>
            <!--v-btn
                flat
                class="hidden-sm-and-down nav-menu"
                to="/menu"
                data-cy="menuBtn"
                >Eventi</v-btn
            >
            <v-btn
                flat
                class="hidden-sm-and-down nav-menu"
                to="/map/0"
                data-cy="menuBtn"
                >Mappa</v-btn
            -->
            <v-spacer class="hidden-sm-and-down"></v-spacer>
            <!--div v-if="!isAuthenticated" class="hidden-sm-and-down">
                <v-btn flat to="/sign-in" data-cy="signinBtn">SIGN IN</v-btn>
                <v-btn
                    color="brown lighten-3"
                    to="/join"
                    class="nav-join"
                    data-cy="joinBtn"
                    >JOIN</v-btn
                >
            </div>
            <div v-else>
                <v-btn flat to="/about">PROFILE</v-btn>
                <v-btn outline color="white" @click="logout" data-cy="logout"
                    >Logout</v-btn
                >
            </div-->
        </v-toolbar>
    </span>
</template>

<script>
export default {
    name: 'AppNavigation',
    data() {
        return {
            appTitle: 'ICRON LIVE RESULTS',
            drawer: false,
            items: [
                { title: 'Eventi', url: '/menu' },
                { title: 'Map', url: '/map' },
                { title: 'Profile', url: '/about' },
                { title: 'Sign In', url: '/sign-in' },
                { title: 'Join', url: '/join' },
            ],
        };
    },
    computed: {
        isAuthenticated() {
            return this.$store.getters.isAuthenticated;
        },
    },
    methods: {
        logout() {
            this.$store.dispatch('userSignOut');
        },
    },
};
</script>

<style scoped>
a {
    color: white;
    text-decoration: none;
}
</style>
